import {ExclamationCircleOutlined, MoreOutlined} from "@ant-design/icons";
import {Button, Dropdown, Menu, Modal, message} from "antd";
import {Link} from "react-router-dom";
import {useDeleteSession} from "../../../../../features/sessions";
import {handleServiceBookingLink} from "../../../../../utils/meeting";
import {useGetProfileContext} from "../../../../../context/profile/profile-context";

type TSessionListMenuOptionProps = {
  serviceId: number;
  slug: string;
  tinyUrl: string;
  isBundle: boolean;
};

export function SessionListMenuOption({
  serviceId,
  slug,
  tinyUrl,
  isBundle,
}: TSessionListMenuOptionProps) {
  const deleteSessionMutation = useDeleteSession();
  const {state: profileState} = useGetProfileContext();

  const handleDeleteModal = () => {
    Modal.confirm({
      title: `Confirm session deletion`,
      content:
        "Are you sure you want to delete this session? This action cannot be undone.",
      icon: <ExclamationCircleOutlined style={{color: "#F5222D"}} />,
      okText: "Delete session",
      cancelText: "Exit",
      okType: "danger",
      okButtonProps: {
        size: "small",
        type: "primary",
        loading: deleteSessionMutation.isLoading,
      },
      cancelButtonProps: {
        size: "small",
        type: "ghost",
      },
      onOk() {
        return new Promise((resolve, reject) => {
          if (serviceId) {
            resolve(
              deleteSessionMutation.mutate(serviceId, {
                onSuccess: () => {
                  message.success("The selected session has been deleted successfully!");
                },
              })
            );
          }
        }).catch(() => message.error("Failed to delete"));
      },
    });
  };
  const menu = (
    <Menu
      items={[
        {
          label: (
            <Link
              to={`/calls${
                isBundle ? "/bundle" : ""
              }/edit/${serviceId}?activeTab=insights`}
            >
              Sales and insights
            </Link>
          ),
          key: "0",
        },
        {
          label: (
            <Link to={`/calls${isBundle ? "/bundle" : ""}/edit/${serviceId}`}>
              Edit session
            </Link>
          ),
          key: "1",
        },
        {
          label: (
            <div
              onClick={() =>
                navigator.clipboard
                  .writeText(
                    handleServiceBookingLink({
                      serviceId: serviceId,
                      slug: slug,
                      username: profileState.profileData.username,
                      tinyUrl: tinyUrl,
                      windowNav: true,
                    })
                  )
                  .then(() => message.success("Copied link"))
              }
            >
              Copy session link
            </div>
          ),
          key: "2",
        },
        {
          label: <div onClick={handleDeleteModal}>Delete session</div>,
          key: "3",
        },
      ]}
    />
  );
  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
        <Button
          shape="circle"
          size="small"
          icon={<MoreOutlined />}
          style={{
            backgroundColor: "transparent",
            color: "#1C1726",
            border: "none",
            boxShadow: "none",
          }}
        />
      </Dropdown>
    </>
  );
}
